import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step17 from './Step17-redux';

export default compose(
  withRouter,
  withNextStep
)(Step17);
